$(function() {
  
        var lista = null;
        var id = 0;

        //    Sliders Swipers
        var swiperEvents = function() {

            var galleryThumbs = new Swiper('.gallery-thumbs', {
                // slidesPerView: 10,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                spaceBetween: 10,
                breakpoints: {
                    1024: {
                        slidesPerView: 5,
                    },
                    768: {
                        slidesPerView: 4,
                    },
                    640: {
                        slidesPerView: 3,
                    },
                    320: {
                        slidesPerView: 2,
                    }
                }
            });

            var galleryTop = new Swiper('.gallery-top', {
                // autoplay: true,
                effect: 'fade',
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: galleryThumbs
                }
            });

        }


        var loadSwiper = function(){
            var galleryTop = new Swiper('.gallery-top', {
              effect: 'fade',
              spaceBetween: 10,
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
            var galleryThumbs = new Swiper('.gallery-thumbs', {
              spaceBetween: 10,
              centeredSlides: true,
              slidesPerView: 'auto',
              touchRatio: 0.2,
              slideToClickedSlide: true,
            });
            galleryTop.controller.control = galleryThumbs;
            galleryThumbs.controller.control = galleryTop;
        }

        function obtener(idea){

            let url = 'https://cdn.shopify.com/s/files/1/0128/2693/5360/t/12/assets/' + idea + '.json?v=0.23'
            //let url = '../assets/json/' + idea + '.json?v=0.1'
            fetch(url)
                .then( res => res.json() )
                .then( datos => {
                    lista = datos;
                    cargarImagenes(datos);
                });
        }

        function cargarImagenes(datos){

            let id = 0;
            let imgHtml = "";

            for(let valor of datos){
                imgHtml += `<div class="swiper-slide cover" id="${id++}" style="background-image: url('${valor.imagen}');">
                </div>`;
            }

            var imgGrandeContenedor = document.querySelector('.gallery-top .swiper-wrapper');
            var imgChicoContenedor = document.querySelector('.gallery-thumbs .swiper-wrapper');
            imgGrandeContenedor.innerHTML = imgHtml;
            imgChicoContenedor.innerHTML = imgHtml;

            var imgChico = document.querySelectorAll('.gallery-thumbs .swiper-wrapper .swiper-slide');
            for(let img of imgChico){
                img.addEventListener('click',function(){mostrarDescripcion(this.id)},false);
            }
            mostrarDescripcion(0);
            //loadSwiper();
            swiperEvents();
        }

        var mostrarDescripcion = function(idImg){
            id = parseInt(idImg);
            let texto = lista[id].descripcion;

            var paso = document.querySelectorAll('.paso');
            if(id > 0){
                    paso[0].innerHTML = "<span>" + id + "</span>";
                    paso[1].innerHTML = "<span>" + id + "</span>";
            }else {
                paso[0].innerHTML = "";
                paso[1].innerHTML = "";
            }

            var descripcion = document.querySelectorAll('.descripcion');
                descripcion[0].innerHTML = texto;
                descripcion[1].innerHTML = texto;

        }

        var flechaDer = document.querySelector('.swiper-button-next');
        var flechaIzq = document.querySelector('.swiper-button-prev');

  		if(flechaDer!=null){
        	flechaDer.addEventListener('click',function(){
            if(id < lista.length){
                id++;
                mostrarDescripcion(id);
                }
            },false);
        }

  		if(flechaIzq!=null){
          flechaIzq.addEventListener('click',function(){
              if(0 < id){
                  id--;
                  mostrarDescripcion(id);
              }
          },false);
        }

        var init = function(){
            let idea_element = document.getElementById('slider-ideas');

            if(idea_element){
              let idea = idea_element.dataset.idea;  
              if(idea) obtener(idea);
            }
        }

        init();

  
});
